import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import {
    CreateMachineTypeBody,
    MachineTypeResponse,
    UpdateMachineTypeBody,
    createMachineType,
    updateMachineType,
} from '../../services/apiSLTP/materials/machinesTypes';

type UseUpdateMachineTypeMutationOptions = MutationOptions<
    MachineTypeResponse,
    Error,
    { machineTypeId: string; data: UpdateMachineTypeBody }
>;

type UseCreateMachineTypeMutationOptions = MutationOptions<
    MachineTypeResponse,
    Error,
    CreateMachineTypeBody
>;

export const useUpdateMachineTypeMutation = (options?: UseUpdateMachineTypeMutationOptions) => {
    const mutationFn: MutationFunction<MachineTypeResponse, { machineTypeId: string; data: UpdateMachineTypeBody }> = async ({
        machineTypeId,
        data,
    }) => {
        try {
            return await updateMachineType(machineTypeId, data);
        } catch {
            throw new Error('An unexpected error occurred during machine type update');
        }
    };

    return useMutation(mutationFn, options);
};

export const useCreateMachineTypeMutation = (options?: UseCreateMachineTypeMutationOptions) => {
    const mutationFn: MutationFunction<MachineTypeResponse, CreateMachineTypeBody> = async (data) => {
        try {
            return await createMachineType(data);
        } catch {
            throw new Error('An unexpected error occurred during machine type creation');
        }
    };

    return useMutation(mutationFn, options);
};
